module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_cuad_2.baa3c5ea.png";